import api from './api'

function normalizeEnum(value) {
  if (value === undefined || value === null || value === '') return undefined
  return String(value).trim().toUpperCase()
}

function normalizeNullableString(value) {
  if (value === undefined || value === null) return undefined
  const trimmed = String(value).trim()
  return trimmed === '' ? undefined : trimmed
}

function normalizeNullableInt(value) {
  if (value === undefined || value === null || value === '') return undefined
  const parsed = Number(value)
  return Number.isInteger(parsed) ? parsed : undefined
}

function buildCondicionPayload(data = {}, { requireCondicion = false } = {}) {
  const idCondicion = normalizeNullableInt(
    data.id_condicion_salud ??
    data.id_condicion ??
    data.idCondicionSalud ??
    data.idCondicion
  )

  if (requireCondicion && !idCondicion) {
    throw new Error('Selecciona una condición de salud válida')
  }

  const payload = {
    // Compatibilidad con distintas validaciones del backend.
    ...(idCondicion ? { id_condicion_salud: idCondicion, id_condicion: idCondicion } : {}),
    ...(normalizeNullableString(data.fecha_diagnostico) ? { fecha_diagnostico: normalizeNullableString(data.fecha_diagnostico) } : {}),
    ...(normalizeNullableInt(data.id_veterinario) ? { id_veterinario: normalizeNullableInt(data.id_veterinario) } : {}),
    ...(normalizeNullableInt(data.id_ficha_clinica) ? { id_ficha_clinica: normalizeNullableInt(data.id_ficha_clinica) } : {}),
    ...(normalizeEnum(data.severidad) ? { severidad: normalizeEnum(data.severidad) } : {}),
    ...(normalizeEnum(data.estado) ? { estado: normalizeEnum(data.estado) } : {}),
    ...(normalizeNullableString(data.notas) ? { notas: normalizeNullableString(data.notas) } : {})
  }

  return payload
}

export const mascotaCondicionService = {
  // Listar condiciones de una mascota
  async getByMascota(idMascota, params = {}) {
    const response = await api.get(`/mascotas/${idMascota}/condiciones`, { params })
    return response.data
  },

  // Obtener condición específica de una mascota
  async getById(idMascota, idCondicion) {
    const response = await api.get(`/mascotas/${idMascota}/condiciones/${idCondicion}`)
    return response.data
  },

  // Asignar condición a una mascota (solo VETERINARIO/ADMIN/SUPERADMIN)
  async create(idMascota, data) {
    const payload = buildCondicionPayload(data, { requireCondicion: true })
    const response = await api.post(`/mascotas/${idMascota}/condiciones`, payload)
    return response.data
  },

  // Actualizar condición de una mascota (solo VETERINARIO/ADMIN/SUPERADMIN)
  async update(idMascota, idCondicion, data) {
    const payload = buildCondicionPayload(data)
    const response = await api.put(`/mascotas/${idMascota}/condiciones/${idCondicion}`, payload)
    return response.data
  },

  // Eliminar condición de una mascota (solo VETERINARIO/ADMIN/SUPERADMIN)
  async delete(idMascota, idCondicion) {
    const response = await api.delete(`/mascotas/${idMascota}/condiciones/${idCondicion}`)
    return response.data
  },
}

